import React from "react";
const Youtube = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
  >
    <ellipse cx="12.609" cy="12" rx="12.0338" ry="12" fill="white" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.1509 8.61974L16.1509 8.61977L16.1606 8.62054C16.5569 8.65176 16.7141 8.72532 16.7643 8.75592L16.7662 8.75712C16.7873 8.76987 16.8299 8.79564 16.8904 8.93587C17.0782 9.37161 17.1685 10.2245 17.1685 12.0209C17.1685 13.8163 17.0786 14.6861 16.8885 15.1312C16.8278 15.2731 16.7864 15.2964 16.7738 15.3036L16.7718 15.3047C16.7332 15.3279 16.5876 15.3982 16.1998 15.4186L16.1998 15.4186L16.1932 15.419C14.3003 15.5267 10.0319 15.527 8.12451 15.42C7.73934 15.3881 7.58556 15.316 7.53605 15.2858L7.53408 15.2846C7.513 15.2719 7.47038 15.2461 7.40993 15.1059C7.22212 14.6701 7.13184 13.8172 7.13184 12.0209C7.13184 10.2245 7.22212 9.37161 7.40993 8.93587C7.47037 8.79564 7.513 8.76987 7.53408 8.75712L7.53605 8.75592C7.58621 8.72532 7.74337 8.65176 8.1397 8.62054L8.1397 8.62057L8.14945 8.61974C10.0201 8.46009 14.2803 8.46009 16.1509 8.61974ZM5.63184 12.0209C5.63184 15.4701 5.90343 16.7497 8.02189 16.9166C9.97739 17.0278 14.3229 17.0278 16.2784 16.9166C18.3969 16.8053 18.6685 15.4701 18.6685 12.0209C18.6685 8.57163 18.3969 7.29207 16.2784 7.12517C14.3229 6.95828 9.97739 6.95828 8.02189 7.12517C5.90343 7.29207 5.63184 8.57163 5.63184 12.0209ZM11.2496 13.8738C10.9169 14.0442 10.5217 13.8025 10.5217 13.4287V10.6137C10.5217 10.2399 10.9169 9.99827 11.2496 10.1686L13.9982 11.5762C14.361 11.762 14.361 12.2805 13.9982 12.4663L11.2496 13.8738Z"
      fill="black"
    />
  </svg>
);

export default Youtube;
